import { CommentDataType, ReplyContentType } from "../../Comment/CommentTypes";
import { PostCommentsInfo } from "@infrastructure/Services/PostCommentsService.types";
import { SxProps } from "@mui/material";

export type CommentFormModalType = {
    clearEditedComment: () => void;
    clearReplyComment: () => void;
    commentFormSubmissionCallback: (update: PostCommentsInfo) => void;
    postId: number | string;
    dialogStyleOverrides?: SxProps;
    editedComment?: CommentDataType;
    replyComment?: ReplyContentType;
    sourceType?: string;
};

export enum FORM_TABS {
    DEFAULT,
}
